import { ArrowUp } from "lucide-react";
import { AiSparkle } from "@/components/common/AiSparkle";

export const starterQuestions = (l) => [
  `How far is ${l?.nearest_base?.short ?? "the nearest base"} from here?`,
  "Closest Italian restaurant?",
  "Nearest elementary school?",
  "Can I use my VA loan on this home?",
];

export const AskChips = ({ questions, onAsk, disabled, testPrefix }) => (
  <div className="flex flex-wrap gap-2">
    {questions.map((q, i) => (
      <button key={q} type="button" disabled={disabled} onClick={() => onAsk(q)} data-testid={`${testPrefix}-chip-${i}`}
        className="flex items-center gap-1.5 rounded-full border border-neutral-300 bg-white px-3.5 py-2 text-left text-[13px] text-ink transition-colors hover:border-ink hover:bg-ink hover:text-white disabled:opacity-50">
        <AiSparkle className="h-3.5 w-3.5 shrink-0" /> {q}
      </button>
    ))}
  </div>
);

export const AskForm = ({ onAsk, busy, testPrefix, placeholder = "Ask anything about this home…" }) => {
  const submit = (e) => {
    e.preventDefault();
    const q = e.currentTarget.elements.q.value.trim();
    if (!q || busy) return;
    onAsk(q);
    e.currentTarget.reset();
  };
  return (
    <div className="ai-glow rounded-full">
      <form onSubmit={submit} className="flex items-center gap-2 rounded-full bg-white p-1.5 pl-4" data-testid={`${testPrefix}-form`}>
      <input name="q" maxLength={500} placeholder={placeholder} autoComplete="off" data-testid={`${testPrefix}-input`}
        className="h-10 min-w-0 flex-1 bg-transparent text-[16px] text-ink placeholder:text-neutral-500 focus:outline-none" />
      <button type="submit" disabled={busy} aria-label="Ask" data-testid={`${testPrefix}-send`}
        className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-ink text-white transition-colors hover:bg-neutral-800 disabled:opacity-50">
        <ArrowUp className="h-4 w-4" />
      </button>
      </form>
    </div>
  );
};
